import React from 'react'
import { Grid, Box } from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'

// Components
import TextField from 'StandardComponents/CustomTextfield/CustomTextField'
import AutoComplete from 'StandardComponents/AutoCompleteTextfield/AutoCompleteTextfield'
import UploadButton from 'StandardComponents/CustomUploadButton/CustomUploadButton'
import Select from 'StandardComponents/CustomedSelect/CustomedSelect'
import TextFieldNumber from 'StandardComponents/TextFieldNumber/TextFieldNumber'
import TextFieldCurrency from 'StandardComponents/TextFieldCurrency/TextFieldCurrency'
import Radio from 'StandardComponents/CustomedRadioButton/CustomedRadioButton'

export default function CreateCashAdvances1stPage(props) {
  const {
    classes,
    onClickAutoComplete,
    onChangeAutoComplete,
    setSuggestionsVatType,
    value,
    suggestionsVendor,
    type,
    suggestionsRequestingDepartment,
    fileError,
    setFileError,
    setButtonColor,
    buttonColor,
    setSuggestionsWtaxRate,
    setSuggestionsRequestingDepartment,
    setSuggestionsProject,
    suggestionsProjects,
    poNumberError,
    handleOnchange,
    suggestionReleasingCenter,
    setSelectedDate,
    handleOnChangeSelect,
    selectedDate,
    params,
    setDisabled,
    // selectedValue,
    // setSelectedValue,
    setValue,
    status,
    setSuggestionsVendors,
    selectedFile,
    setSelectedFile,
    errors
  } = props

  const handleDateChange = (date) => {
    setSelectedDate(date);
  }

  const handleOnChangeFile = event => {
    if (event.target.name === 'file' && event.target.files.length !== 0) {
      let fileName = event.target.files[0].name.split('.')
      let fileExtension = fileName[fileName.length - 1]
      setValue({ ...value, file: event.target.files[0], selectedFile: event.target.files[0].name })
      setSelectedFile({
        file: event.target.files[0].name
      })
      if (fileExtension !== 'pdf') {
        setFileError('wrong')
        setButtonColor('red')
        setDisabled(true)
      } else {
        setFileError('correct')
        setButtonColor('green')
        setDisabled(false)
      }
    }
  }
  return (
    <React.Fragment>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid constainer style={{ marginLeft: '100px', marginRight: '70px' }}>
          <Grid item xs={12}>
            <KeyboardDatePicker
              margin='normal'
              className={classes.date}
              label='Due date'
              format='MM/dd/yyyy'
              value={selectedDate}
              onChange={(e) => {
                handleDateChange(e)
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              error={errors.dueDate}
            />
          </Grid>
          {type === 'PO Item' && (
            <Grid item xs={6} style={{ marginBottom: '16px', marginTop: '10px' }}>
              <TextFieldNumber
                label='PO Number'
                value={value.poNumber}
                onChange={value => handleOnchange(value, 'poNumber')}
                error={poNumberError}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <AutoComplete
              label='Vendor/Payee'
              constainerStyle={{ width: '100%', height: '10%', overflow: 'auto' }}
              value={value.vendor}
              onClick={() => {
                onClickAutoComplete({
                  name: 'vendor',
                  value: value,
                  setSuggestions: setSuggestionsVendors,
                  setSuggestionsVatType: setSuggestionsVatType,
                  params: params
                })
              }}
              suggestions={suggestionsVendor}
              onChange={(event, isClick) => {
                onChangeAutoComplete({
                  event: event,
                  isSuggestionClick: isClick,
                  name: 'vendor',
                  setSuggestionsWtaxRate: setSuggestionsWtaxRate,
                  setSuggestionsVatType: setSuggestionsVatType,
                  value: value,
                  params: params,
                  setSuggestion: setSuggestionsVendors,
                  suggestion: suggestionsVendor,
                  setValue: setValue
                })
              }}
              error={errors.vendor}
            />
          </Grid>
          <Grid item xs={12}>
            <Select
              label='Requesting Department'
              constainerStyle={{ width: '100%', height: '10%', overflow: 'auto' }}
              value={value.department}
              name={'department'}
              suggestions={suggestionsRequestingDepartment}
              onChange={handleOnChangeSelect}
              onClick={() => {
                onClickAutoComplete({
                  name: 'department',
                  value: value,
                  setSuggestions: setSuggestionsRequestingDepartment,
                  params: params
                })
              }}
              error={errors.department}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              constainerStyle={{ width: '100%' }}
              value={value.particulars}
              placeholder={'Enter particulars...'}
              name='particulars'
              onChange={value => handleOnchange(value, 'particulars')}
              label='Particulars'
              required
              error={errors.particulars}
            />
          </Grid>
          <Grid item xs={12}>
            <AutoComplete
              label='Projects'
              constainerStyle={{ width: '100%', height: '10%', overflow: 'auto' }}
              value={value.project}
              onClick={() => {
                onClickAutoComplete({
                  name: 'project',
                  value: value,
                  setSuggestions: setSuggestionsProject,
                  params: params
                })
              }}
              suggestions={suggestionsProjects}
              onChange={(event, isClick) => {
                onChangeAutoComplete({
                  event: event,
                  isSuggestionClick: isClick,
                  name: 'project',
                  value: value,
                  params: params,
                  setSuggestion: setSuggestionsProject,
                  suggestion: suggestionsProjects,
                  setValue: setValue
                })
              }}
              error={errors.project}
            />
          </Grid>
          <Grid item xs={12}>
            <Select
              label='Releasing Center'
              constainerStyle={{ width: '100%', height: '10%', overflow: 'auto' }}
              value={value.releasingCenter}
              name={'releasingCenter'}
              suggestions={suggestionReleasingCenter}
              onChange={handleOnChangeSelect}
            />
          </Grid>
          <Grid item xs={5} style={{ marginBottom: '40px' }}>
            <TextFieldCurrency
              label='Amount'
              value={value.amount}
              onChange={value => handleOnchange(value, 'amount')}
              error={errors.amount}
            />
          </Grid>
          <Grid item xs={12}>
            <div className={classes['file-upload-container']}>
              <UploadButton
                placeholder={'Upload ATD (Authority to Deduct) must be a pdf file....'}
                onChange={handleOnChangeFile}
                value={value.selectedFile}
                fileError={fileError}
                setButtonColor={setButtonColor}
                setValue={setValue}
                buttonColor={buttonColor}
                mainValue={value}
                readOnly
                setFileError={setFileError}
                setSelectedFile={setSelectedFile}
                error={errors.selectedFile}
              />
            </div>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </React.Fragment>
  )
}
